import { httpService } from '~/Services/Service';
import { salvarEmExcel } from '~/Utils/Helpers';

// W-0627 — Relatório Carteira por Conta Capital
// Fonte backend: Setpar.APIRest/Controllers/Relatorios/CarteiraPorContaCapitalController.cs
// RoutePrefix: "relatorios/carteira-conta-capital" (sem /api/ — APIBASE já cobre)

const BASE = '/relatorios/carteira-conta-capital';

const obterGesDisponiveis = () => httpService.get(`${BASE}/ges`);

const obterGruposGe = () => httpService.get(`${BASE}/grupos-ge`);

// Backend serializa List<int> GEs (PascalCase em C#) como "g_es" (SnakeCaseStrategy
// quebra cada letra maiúscula). MEMORY.md backend Decisão 1 / Ciclo 7 L6 SnakeCase edge.
const gerarRelatorio = (ges) => httpService.post(`${BASE}/gerar`, { g_es: ges });

const exportarExcel = (ges) => salvarEmExcel({ g_es: ges }, `${BASE}/exportar-excel`);

export default { obterGesDisponiveis, obterGruposGe, gerarRelatorio, exportarExcel };
